import { render, staticRenderFns } from "./GroupNew.vue?vue&type=template&id=1d40442e"
import script from "./GroupNew.vue?vue&type=script&lang=js"
export * from "./GroupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports